{
  "REGISTER-FUEL--FUELING-LABEL":"Abastecida",
  "REGISTER-FUEL--REFUELING":"Informe os dados da abastecida",
  "REGISTER-FUEL--VEHICLE":"Veículo",
  "REGISTER-FUEL--SELECT":"Selecionar",
  "REGISTER-FUEL--DRIVER":"Motorista",
  "REGISTER-FUEL--LOCATION":"Local de abastecimento",
  "REGISTER-FUEL--SUPPLIER":"Fornecedor",
  "REGISTER-FUEL--INVOICE":"Número da nota",
  "REGISTER-FUEL--AMOUNT":"Valor(R$)",
  "REGISTER-FUEL--LITERS":"Litros Abastecidos",
  "REGISTER-FUEL--TYPE":"Tipo de Combustível",
  "REGISTER-FUEL--ODOMETER":"Hodômetro",
  "REGISTER-FUEL--HOURMETER":"Horímetro",
  "REGISTER-FUEL--NOTE":"Observação (opcional)",
  "REGISTER-FUEL--ONLY-RECEIPT":"Comprovante",
  "REGISTER-FUEL--RECEIPT":"Selecione um comprovante",
  "REGISTER-FUEL--PHOTO":"Tirar Foto do Comprovante",
  "REGISTER-FUEL--SUBMIT":"Enviar",

  "REGISTER-FUEL--REGULAR-GASOLINE": "Gasolina Comum",
  "REGISTER-FUEL--ADDITIVE-GASOLINE": "Gasolina Aditivada",
  "REGISTER-FUEL--PREMIUM-GASOLINE": "Gasolina Premium",
  "REGISTER-FUEL--REGULAR-DIESEL": "Diesel Comum",
  "REGISTER-FUEL--DIESEL-S10": "Diesel S-10",
  "REGISTER-FUEL--ADDITIVE-DIESEL": "Diesel Aditivado",
  "REGISTER-FUEL--PREMIUM-DIESEL": "Diesel Premium",
  "REGISTER-FUEL--REGULAR-ETHANOL": "Etanol Comum",
  "REGISTER-FUEL--ADDITIVE-ETHANOL": "Etanol Aditivado",
  "REGISTER-FUEL--ALCOHOL": "Álcool",
  "REGISTER-FUEL--CNG": "GNV",
  "REGISTER-FUEL--ARLA": "ARLA",
  "REGISTER-FUEL--FETCHING-DATA": "Obtendo dados ...",
  "REGISTER-FUEL--FETCH-DATA-FAILED": "Não foi possível obter dados!",
  "REGISTER-FUEL--FETCHING-ADDRESS": "Obtendo endereço ...",
  "REGISTER-FUEL--LOCATION-INACCURATE": "A localização pode estar imprecisa...",
  "REGISTER-FUEL--INVALID-FIELDS": "Campos invalidos!",
  "REGISTER-FUEL--ODOMETER-OR-HOURMETER-REQUIRED": "Informe ao menos o hodômetro ou horímetro!",
  "REGISTER-FUEL--SAVING": "Salvando ...",
  "REGISTER-FUEL--TRY-AGAIN-LATER": "Tente novamente mais tarde...",
  "REGISTER-FUEL--FUEL-REGISTERED": "Abastecimento registrado!"
}
